import { motion } from "framer-motion";
import { ShieldCheck, QrCode, BadgeCheck } from "lucide-react";
import { useContent } from "../context/ContentContext";
import { imgUrl } from "../lib/api";

const DEFAULT_IMG =
  "https://landerpharma.com.py/rails/active_storage/blobs/redirect/eyJfcmFpbHMiOnsiZGF0YSI6MTg4LCJwdXIiOiJibG9iX2lkIn19--5d9d61deb75088a0133a3ac7970d94ecfb641fa8/HCG.png";

const ICONS = [ShieldCheck, QrCode, BadgeCheck];

export default function Quality() {
  const content = useContent();
  const q = content.quality;
  const highlights = q.highlights || [];
  const img = content.quality_image ? imgUrl(content.quality_image) : DEFAULT_IMG;

  return (
    <section id="calidad" className="mx-auto max-w-7xl px-5 py-24 lg:px-8 lg:py-32" data-testid="quality-section">
      <div className="grid items-center gap-12 lg:grid-cols-2">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8 }}
        >
          <p className="font-mono mb-4 text-xs uppercase tracking-[0.3em] text-brand">
            {q.overline}
          </p>
          <h2 className="font-display text-2xl font-bold uppercase tracking-tight text-neutral-900 sm:text-3xl lg:text-4xl">
            {q.title}
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-neutral-500 sm:text-base">
            {q.text}
          </p>
          <div className="mt-8 space-y-4">
            {highlights.map((h, i) => {
              const Icon = ICONS[i % ICONS.length];
              return (
                <motion.div
                  key={i}
                  initial={{ opacity: 0, x: -24 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: i * 0.12, duration: 0.6 }}
                  className="flex gap-4 rounded-2xl border border-[#E8E4D9] bg-white p-4 shadow-sm"
                  data-testid={`quality-highlight-${i}`}
                >
                  <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-brand-light text-brand">
                    <Icon size={20} />
                  </div>
                  <div>
                    <h3 className="font-display text-base font-bold text-neutral-900">{h.title}</h3>
                    <p className="mt-1 text-sm leading-relaxed text-neutral-500">{h.desc}</p>
                  </div>
                </motion.div>
              );
            })}
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, scale: 0.96 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
          className="relative"
        >
          <div className="flex items-center justify-center overflow-hidden rounded-3xl border border-[#E8E4D9] bg-white shadow-sm">
            <img src={img} alt="Calidad y autenticidad Landerlan" className="max-h-[520px] w-full object-contain py-8" />
          </div>
          <div className="glass absolute -bottom-6 -left-4 rounded-2xl border border-brand/30 p-5 shadow-lg sm:-left-8" data-testid="quality-badge">
            <p className="font-display text-3xl font-black text-brand">GMP</p>
            <p className="mt-1 font-mono text-[10px] uppercase tracking-widest text-neutral-500">
              Buenas prácticas certificadas
            </p>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
